import styled from "styled-components";

export const Container = styled.div`
  max-width: 1423px;
  margin: 0 auto;
  width: 100%;
  padding: 0 10px;
  .clear-btn {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 10px;
  } 
  .btn1{
margin-right:5px
  }
  .btn2{
margin-left:5px
  }   
  .active {
    background-color: #f0f0f0;
    color: #0a5587;
  }
  @media (max-width: 1250px) {
    padding: 0 15px;
  }
  > h2 {
    text-align: center;
    color: #0a1f30;
    font-size: 26px;
    padding: 10px 0;
  }
  .MuiTabs-vertical {
    min-width: 270px;
  }
  .MuiTab-wrapper {
    align-items: flex-start;
  }

  .MuiTab-root {
    background-color: #ffffff;
    text-transform: capitalize;
    max-width: none;
    margin-bottom: 0;
    padding: 10px 15px !important;
    border-bottom: 1px solid #e1e1e1;
    color: #0a5587;
    font-size: 14px;
    opacity: 1;
  }
  .Mui-selected {
    background-color: #f0f0f0;
    color: #0a5587;
  }
`;
export const NoRecordFound = styled.div`
  text-align: center;
  padding-top: 2%;
  padding-bottom: 4%;
`;
export const NotificationWrapper = styled.div`
  box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);
  position: relative;
  .notification-box-wrapper{
    max-height: 540px;
    overflow-y: auto;
    margin-bottom: 10px;
  }
`;
export const ShowButton = styled.div`
  width: 122px;
  background: #fff;
  padding: 16px;
  text-align: center;
  color: #0a5587;
  cursor: pointer;
  margin: 0 auto;
`;

export const Box = styled.div`
  border-bottom: solid 1px #87cdf1;
  cursor: pointer;
  display: flex;
  align-items: center;
  position: relative;
  &:last-of-type {
    border-bottom: none;
  }
  .dot {
    height: 8px;
    width: 8px;
    border-radius: 50%;
    background-color: #0bb4ff;
    display: block;
    position: absolute;
    left: 13px;
    margin-top: 10px;
  }
  > div {
    display: flex;
    padding: 20px;
    flex: 1;
    position: relative;
    z-index: 0;
  }
`;

export const ImageWrapper = styled.div`
  width: 94px;
  height: 94px;
  margin: 0 15px;
  border-radius: 10px;
  overflow: hidden;
  img {
    width: 100%;
  }
`;

export const TextWrapper = styled.div`
  flex: 1;
  .clear-icon {
    position: relative;
    z-index: 1;
  }
  > div {
    display: flex;
    align-items: baseline;
    margin-left: 10px;
    justify-content: space-between;
    > h4 {
      font-size: 16px;
    }
    > span {
      display: inline-flex;
      svg {
        margin-left: 10px;
      }
    }
  }
  > p {
    font-size: 14px;
    margin-bottom: 0;
    max-height: 66px;
    overflow: hidden;
  }
`;

export const ContainerWrapper = styled.div`
  .button-wrapper{
    display: flex;
    justify-content: end;
    margin-bottom: 10px;
  }
  .inner-tab-wrapper {
    width: 100%;
  }
  .MuiAccordionSummary-root.Mui-expanded {
    min-height: 54px;
    .MuiAccordionSummary-content.Mui-expanded {
      margin: 15px 0;
    }
  }
  .MuiAccordionDetails-root {
    padding-left: 0;
    padding-right: 0;
  }
  .MuiButtonBase-root {
    position: relative;
  }
  .MuiAccordionSummary-expandIcon {
    position: absolute;
    right: 43px;
  }
  .MuiAccordionSummary-content {
    position: relative;
  }
  .notification {
    /* top: -35px; */
    color: #080808;
    /* right: -222px; */
    min-width: 30px;
    position: relative;
    /* max-height: 0; */
    z-index: 1;
    font-size: 14px;
    margin: 0;
    display: flex;
    justify-content: center;
    position: absolute;
    right: -10px;
    top: -4px;
    border-radius: 50%;
    height: 30px;
    background: #00b3ff;
    align-items: center;
    @media (max-width: 767px) {
      right: calc(100% - 200% + 41px);
    }
    .bg {
      position: absolute;
      background: #ffc400;
      width: 33px;
      height: 33px;
      right: -1px;
      z-index: -1;
      top: -6px;
      border-radius: 50%;
      display: none;
    }
  }
`;

export const UnTab = styled.div`
  position: relative;
  .notification {
    right: 6px;
    top: 9px;
  }
`;

export const InnerTab = styled.div`
  position: relative;
  .inner-text {
    padding: 10px;
  }
  .notification {
    top: 8px;
    right: 5px;
  }
`;

export const BoxWrapper = styled.div`
  /* Styles for the wrapper */
`;

export const NotificationContent = styled.div`
  /* Styles for the notification content */
`;

export const TitleSection = styled.div`
  /* Styles for the title section */
`;

export const MessageSection = styled.div`
  /* Styles for the message section */
`;

export const DateTime = styled.div`
  /* Styles for the date/time */
`;

export const CloseIcon = styled.div`
  /* Styles for the close icon */
`;

export const CloseIconGroup = styled.div`
  /* Styles for the close icon group */
`;

export const TransactionBtn = styled.div`
  /* Styles for the transaction button */
`;

export const MarkRead = styled.div`
  /* Styles for the mark read button */
`;
